const SUBDOMAINS = {
  LOCALHOST: 'localhost',
  MAIN: 'app',
  WINC: 'winc',
  ROSEBANKSC: 'rosebanksc',
  JIS: 'jis',
  HILLCRESTCC: 'hillcrestcc',
  STLAURENCE: 'slc',
  S_CROSS: 'sccc',
  BEAUDESERT: 'beaudesertshs',
  ROCKHAMPTON: 'rockhamptonshs',
  PGONLINE: 'pgonline',
  PRSPNE: 'prspne',
  ISFWATERLOO: 'isfwaterloo',
  ALBANYSHS: 'albanyshs',
  AVIATIONHIGH: 'aviationhigh',
  AVILACOLLEGE: 'avilacollege',
  BILOELASHS: 'biloelashs',
  BSSSC: 'bsssc',
  BUNDABERGSHS: 'bundabergshs',
  GYMPIESHS: 'gympieshs',
  MALANDASHS: 'malandashs',
  MOSSMANSHS: 'mossmanshs',
  WMYC: 'wmyc',
  NAMBOURSC: 'namboursc',
  NANANGOSHS: 'nanangoshs',
  PEDARECC: 'pedarecc',
  PROSERPINESHS: 'proserpineshs',
  REDBANKPLAINSSHS: 'redbankplainsshs',
  SPRINGFIELDCENTRALSHS: 'springfieldcentralshs',
  STJAMESCOLLEGE: 'stjamescollege',
  SPCC: 'spcc',
  TANNUMSANDSSHS: 'tannumsandsshs',
  TCCR: 'tccr',
  VPSHS: 'vpshs',
  WSSC: 'wssc',
  WOODCRESTSC: 'woodcrestsc',
  YERONGASHS: 'yerongashs',
  SUNCOASTCC: 'suncoastcc',
  CHANCELLORSC: 'chancellorsc',
  INDOOROOSHS: 'indoorooshs',
  STMARYSCOLLEGE: 'stmaryscollege',
  SAMPOERNAACADEMY: 'sampoernaacademy',
  ASPLEYSHS: 'aspleyshs',
  WARWICKSHSWA: 'warwickshs',
  WYNNUMSHS: 'wynnumshs',
  TRINITYBAYSHS: 'trinitybayshs',
  SISSCHOOLS: 'sisschools',
  CHARTERHOUSEALMATY: 'charterhousealmaty',
  EMMAUS: 'emmaus',
  CALLIOPE: 'calliopeshs',
  ATHERTON: 'athertonshs',
  PRONIN: 'proninib',
  TRANSYLVANIA: 'transylvania',
  VICTORYCOLLEGE: 'victorycollege',
  BMEZY: 'bmezy',
  PERIDIS: 'peridis',
  CALVARY: 'calvary',
  SCOTSPGC: 'scotspgc',
} as const;

export { SUBDOMAINS };
